import { Modal } from 'react-bootstrap';
import { LuCopy } from "react-icons/lu";
import useCommonFunctions from '../../../Pages/Shop/Hooks/MobileAndDesktopCommon/useCommonFunctions';
import useGetBankTransferData from '../../BasketPage/Hooks/useGetBankTransferData';
import { useAuth } from '../../../Providers/AuthProvider';

const PaymentDataModal = ({ show, onHide }) => {
    const { authState } = useAuth()
    const { handleCopyToClipboard } = useCommonFunctions()
    const { bankTransferData } = useGetBankTransferData(authState.siteId)

    if (!bankTransferData) {
        return null
    }
    return (
        <>
            <Modal size='lg' show={show} onHide={onHide} centered>
                <Modal.Header closeButton={false}>
                    <Modal.Title>Zasilenie konta</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='main-container-holder row d-flex flex-column text-center'>
                        <span>Wykonaj przelew na dane:</span>
                        <div className='d-flex justify-content-center align-items-center' onClick={() => handleCopyToClipboard(bankTransferData.companyName)}>
                            <b>{bankTransferData.companyName}</b>
                            <LuCopy className='ms-3 primary-accent-color-text element-pointer' />
                        </div>
                        <span className='mt-3'>{bankTransferData.bankName}</span>
                        <div className='d-flex justify-content-center align-items-center' onClick={() => handleCopyToClipboard(bankTransferData.accountNo)}>
                            <b>{bankTransferData.accountNo}</b>
                            <LuCopy className='ms-3 primary-accent-color-text element-pointer' />
                        </div>
                        <div className='d-flex justify-content-center align-items-center' onClick={() => handleCopyToClipboard(`Wpłata ${authState.custId}`)}>
                            <span>Tytułem <b>{`Wpłata ${authState.custId}`}</b></span>
                            <LuCopy className='ms-3 primary-accent-color-text element-pointer' />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex flex-column'>
                        <button className='btn-app-primary me-3' onClick={onHide}>OK</button>
                    </div>
                </Modal.Footer>
            </Modal >
        </>
    )
}

export default PaymentDataModal